/**
 *公告方法
 */
import axios from '@/request/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块
import ctx from '@/main.js'
import homePage from './homePage/homePage.js'
const common = {
  //转换时间格式
  dateFormat: function (datetime, fmt) {
    if (parseInt(datetime) == datetime) {
      if (datetime.length == 10) {
        datetime = parseInt(datetime) * 1000;
      } else if (datetime.length == 13) {
        datetime = parseInt(datetime);
      }
    }
    datetime = new Date(datetime);
    var o = {
      "M+": datetime.getMonth() + 1, //月份
      "d+": datetime.getDate(), //日
      "h+": datetime.getHours(), //小时
      "m+": datetime.getMinutes(), //分
      "s+": datetime.getSeconds(), //秒
      "q+": Math.floor((datetime.getMonth() + 3) / 3), //季度
      "S": datetime.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (datetime.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  },
  getDay: function (day) {
    var today = new Date();
    var targetday_milliseconds = today.getTime();
    if (day == 0) {
      targetday_milliseconds = today.getTime();
    } else {
      targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
    }
    today.setTime(targetday_milliseconds); //注意，这行是关键代码
    var tYear = today.getFullYear();
    var tMonth = today.getMonth();
    var tDate = today.getDate();
    var a = tMonth + 1;
    var b = tDate;
    if (a < 10) {
      a = "0" + a
    }
    if (b < 10) {
      b = "0" + b;
    }
    return tYear + "-" + a + "-" + b;
  },
  //字符串转时间戳
  stringToDate: function (str) {
    var tempStrs = str.split(" ");
    var dateStrs = tempStrs[0].split("-");
    var year = parseInt(dateStrs[0], 10);
    var month = parseInt(dateStrs[1], 10) - 1;
    var day = parseInt(dateStrs[2], 10);
    var timeStrs = tempStrs[1].split(":");
    var hour = parseInt(timeStrs[0], 10);
    var minute = parseInt(timeStrs[1], 10);
    var second = parseInt(timeStrs[2], 10);
    var date = new Date(year, month, day, hour, minute, second);
    return date;
  },
  //截取地址栏中url的参数值
  getQueryString: function (name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = decodeURI(window.location.search.substr(1)).match(reg);
    if (r != null) {
      return unescape(decodeURI(r[2]));
    } else {
      return null;
    }
  },
  //判断是否在某时间段内
  time_range: function (beginTime, endTime) {
    var strb = beginTime.split(":");
    if (strb.length < 2) {
      return false;
    }
    var stre = endTime.split(":");
    if (stre.length < 2) {
      return false;
    }
    var b = new Date();
    var e = new Date();
    var n = new Date();
    b.setHours(strb[0]);
    b.setMinutes(strb[1]);
    e.setHours(stre[0]);
    e.setMinutes(stre[1]);
    if (n.getTime() - b.getTime() > 0 && n.getTime() - e.getTime() < 0) {
      return true;
    } else {
      return false;
    }
  },

  //判断是否为单双号
  is_buyDate: function (buyDate) {
    //下单时间（0：无限制，1：单号下单，2：双号下单）
    var date = new Date();
    var t = date.getDate();
    var t1 = ((t % 2 == 0) ? 2 : 1);
    if (buyDate == 0) {
      return 0;
    }
    return t1
  },
  //判断字符是否为空
  isEmpty: function (obj) {
    if (typeof obj == undefined || obj == "null" || obj == "" || obj == null) {
      return true;
    } else {
      return false;
    }
  },
  //按钮+号点击事件
  addBuyNum(item) {
    item.buyNum = Number(item.buyNum)
    switch (item.goodsLessFlag) {
      case 1:
        item.buyNum = item.buyNum + 1;
        break;
      case 3:
        if (item.buyNum < item.lessLimit) {
          item.buyNum = item.lessLimit
        } else {
          item.buyNum = item.buyNum + 1;
        }
        break; //当商品起订量标志为1-无限制或3-按最小起订量时，每次增加数量为1
      case 2:
        if (item.lessLimit && item.lessLimit != 0) {
          item.buyNum = item.buyNum + item.lessLimit;
        } else {
          item.buyNum = item.buyNum + 1;
        }
        break; //当商品起订量标志为2-按起订量倍数时，每次增加数量为商品起订量
      default:
        item.buyNum = item.buyNum + 1;
        break;
    }
    item.buyNum = Number((item.buyNum).toFixed(2));
  },
  //按钮-号点击事件
  subBuyNum(item) {
    item.buyNum = Number(item.buyNum);
    switch (item.goodsLessFlag) {
      case 1: //当商品起订量标志为1-无限制时，只要数量大于1，即每次点击减一
        if (item.buyNum >= 1) {
          item.buyNum--;
        }
        break;
      case 3: //当商品起订量标志为3-按最小起订量时，只要数量大于商品起订量，即每次点击减一
        if (item.buyNum > item.lessLimit) {
          item.buyNum--;
        } else {
          item.buyNum = 0;
        }
        break;
      case 2: //当商品起订量标志为2-按起订量倍数时，只要数量大于商品起订量，即每次点击减去商品起订量
        if (item.buyNum >= item.lessLimit) { //大于起订量时减去起订量数量
          if (!item.lessLimit || item.lessLimit == 0) {
            item.lessLimit = 1;
          }
          item.buyNum = item.buyNum - item.lessLimit;
        } else { //小于起订量时，数量等于0
          item.buyNum = 0;
        }
        break;
      default:
        if (item.buyNum >= 1) {
          item.buyNum--;
        }
        break;
    }
    item.buyNum = Number((item.buyNum).toFixed(2));
  },
  //加入购物车数量输入框光标移除事件
  changeBuyNum(item) {
    switch (item.goodsLessFlag) {
      case 1: //当商品起订量标志为1-无限制时，只要输入的值小于1，即设置值为1，其他不用变
        // if (item.buyNum < 1) {
        //   item.buyNum = 1;
        // }
        break;
      case 2: //当商品起订量标志为2-按起订量倍数时
        if (item.buyNum < 1) {
          //输入的值小于1，即数量变为商品起订量
          item.buyNum = item.goodsLessLimit;
        } else {
          //输入的值大于1时，数量为输入数量/商品起订量向上取整再乘以商品起订量
          item.buyNum =
            item.lessLimit *
            Math.ceil(item.buyNum / item.lessLimit);
        }
        break;
      case 3: //当商品起订量为3-按最小起订量时，输入的值小于最小起订量，即设置值为最小起订量，其他情况不用变
        if (item.buyNum <= item.lessLimit) {
          item.buyNum = item.lessLimit;
        }
        break;
      default:
        // if (item.buyNum <= 1) {
        //   item.buyNum = 1;
        // }
        break;
    }
    item.buyNum = Number((item.buyNum).toFixed(2));
  },
  //设置cookie值
  setCookie: function (name, value, day) {
    var Days = day;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
  },
  //获取后台传来页面cookie值
  getCookie: function (name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
      return unescape(arr[2]);
    else
      return null;
  },
  //删除cookie
  delCookie: function (name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = this.getCookie(name);
    if (cval != null) {
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    }
  },
  getType(o) {
    let _t
    return ((_t = typeof (o)) == "object" ? o == null && "null" || Object.prototype.toString.call(o).slice(8, -1) : _t).toLowerCase()
  },
  // 深拷贝
  deepCopy(source) {
    let destination = this.getType(source) == "array" ? [] : {}
    for (var p in source) {
      if (!source.hasOwnProperty(p)) continue
      if (this.getType(source[p]) == "array" || this.getType(source[p]) == "object") {
        destination[p] = this.getType(source[p]) == "array" ? [] : {};
        destination[p] = this.deepCopy(source[p]);
      } else {
        destination[p] = source[p];
      }
    }
    return destination
  },
  /**
 * @desc 函数节流
 * @param func 函数
 * @param wait 延迟执行毫秒数
 * @param type 1 使用表时间戳，在时间段开始的时候触发 2 使用表定时器，在时间段结束的时候触发
 */
  throttle(func, wait = 1000, type = 1) {
    let previous = 0;
    let timeout;
    return function () {
      let context = this;
      let args = arguments;
      if (type === 1) {
        let now = Date.now();

        if (now - previous > wait) {
          func.apply(context, args);
          previous = now;
        }
      } else if (type === 2) {
        if (!timeout) {
          timeout = setTimeout(() => {
            timeout = null;
            func.apply(context, args)
          }, wait)
        }
      }
    }
  },
  //获取门店编号
  async getStoreNo() {
    let userKey = await this.getUserKey()
    let fpSysUser = JSON.parse(this.getCookie(userKey));
    if (this.isEmpty(fpSysUser)) {
      return "";
    } else {
      return fpSysUser.branchNo;
    }
  },
  speciahCharacters(val) {
    let newValue = val
    let iconRule2 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
    if (iconRule2.test(newValue)) {
      newValue = newValue.replace(iconRule2, '')
    }
    return newValue
  },
  async getCompanyComfigByAppId(appId) {
    let params = {
      appId
    }
    let res = await homePage.getCompanyComfigByAppId(params)
    var result = res.data;
    if (result.status == 200) {
      return result.data.companyId
    } else {
      return ''
    }
  },
  //获取userKey
  getUserKey: async function () {
    let userKey = 'user'
    if (JSON.parse(JSON.stringify(localStorage.getItem("isCust")))) { //为定制版本
      let appId = "";
      //获取小程序appId信息并截取出url中的appid参数
      let reg = new RegExp("(^|&)appId=([^&]*)(&|$)", "i");
      let r = decodeURI(window.location.search.substr(1)).match(reg);
      if (r != null) {
        appId = unescape(decodeURI(r[2]));
        let companyId = localStorage.getItem(`relationShip_${appId}`);
        // 获取对应appid定制版本的企业id
        if (companyId > 0) {
          userKey = `${userKey}_${companyId}_${appId}`
        } else {
          companyId = await this.getCompanyComfigByAppId(appId)
          if (companyId) {
            userKey = `${userKey}_${companyId}_${appId}`
            console.log(userKey,'userKey1');
          }
        }
      }
    }
    console.log(userKey,'userKey2');
    return userKey
  },
  //获取user信息
  getUser: async function () {

    let userKey = await this.getUserKey()
    console.log(userKey,'userKey3');
    //获取用户
    let user = ctx.$cookies.get(userKey);
    console.log(user,'user');
    return user

  },
  setRelation(appid, companyId) {
    //首先判断是否存在该relation
    let appInfo =  localStorage.getItem(`relationShip_${appid}`)
    if (!appInfo || appInfo == 'undefined') {
      appInfo = '{}'
    }
    let relation = JSON.parse(appInfo)
    if (Object.keys(relation).length <= 0) {
      localStorage.setItem(`relationShip_${appid}`, companyId);
    }
  },
  setModelColor(color) {
    if (JSON.parse(JSON.stringify(localStorage.getItem("isCust")))) { //为定制版本
      let appId = "";
      //获取小程序appId信息并截取出url中的appid参数
      let reg = new RegExp("(^|&)appId=([^&]*)(&|$)", "i");
      let r = decodeURI(window.location.search.substr(1)).match(reg);
      if (r != null) {
        appId = unescape(decodeURI(r[2]));
        // 获取对应appid定制版本的企业id
        localStorage.setItem(`relationShipModelColor_${appId}`, color);
      } else {
        localStorage.setItem(`modelColor`, color);
      }
    }
  },
  getModelColor: function () {
    let modelColor = localStorage.getItem('modelColor');
    if (JSON.parse(JSON.stringify(localStorage.getItem("isCust")))) { //为定制版本
      let appId = "";
      //获取小程序appId信息并截取出url中的appid参数
      let reg = new RegExp("(^|&)appId=([^&]*)(&|$)", "i");
      let r = decodeURI(window.location.search.substr(1)).match(reg);
      if (r != null) {
        appId = unescape(decodeURI(r[2]));
        let color = localStorage.getItem(`relationShipModelColor_${appId}`);
        // 获取对应appid定制版本的企业id
        if (color) {
          modelColor = color
        }
      }
    }
    return modelColor
  },
  setCustomization(customization) {
    if (JSON.parse(JSON.stringify(localStorage.getItem("isCust")))) { //为定制版本
      let appId = "";
      //获取小程序appId信息并截取出url中的appid参数
      let reg = new RegExp("(^|&)appId=([^&]*)(&|$)", "i");
      let r = decodeURI(window.location.search.substr(1)).match(reg);
      if (r != null) {
        appId = unescape(decodeURI(r[2]));
        // 获取对应appid定制版本的企业id
        document.title = customization.companyName;
        localStorage.setItem(`relationShipCustomization_${appId}`, JSON.stringify(customization));
      }
    }
  },
  getCustomization: function () {
    let customization = {}
    if (JSON.parse(JSON.stringify(localStorage.getItem("isCust")))) { //为定制版本
      let appId = "";
      //获取小程序appId信息并截取出url中的appid参数
      let reg = new RegExp("(^|&)appId=([^&]*)(&|$)", "i");
      let r = decodeURI(window.location.search.substr(1)).match(reg);
      if (r != null) {
        appId = unescape(decodeURI(r[2]));
        customization = JSON.parse(localStorage.getItem(`relationShipCustomization_${appId}`));
      }
    }
    return customization
  },
  //获取appid
  getAppId: function () {
    let appId = "";
    if (JSON.parse(JSON.stringify(localStorage.getItem("isCust")))) { //为定制版本
      //获取小程序appId信息并截取出url中的appid参数
      let reg = new RegExp("(^|&)appId=([^&]*)(&|$)", "i");
      let r = decodeURI(window.location.search.substr(1)).match(reg);
      if (r != null) {
        appId = unescape(decodeURI(r[2]));
      }
    }
    return appId
  },
  getCompanyIdByAppId: function () {
    let companyId = ""
    if (JSON.parse(JSON.stringify(localStorage.getItem("isCust")))) { //为定制版本
      let appId = "";
      //获取小程序appId信息并截取出url中的appid参数
      let reg = new RegExp("(^|&)appId=([^&]*)(&|$)", "i");
      let r = decodeURI(window.location.search.substr(1)).match(reg);
      if (r != null) {
        appId = unescape(decodeURI(r[2]));
        companyId = localStorage.getItem(`relationShip_${appId}`);
      }
    }
    return companyId
  },
  async encrypt(data, key = 'fp_ld_8848_8848X') {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(data);
    const encryptedData = await crypto.subtle.encrypt(
        {
            name: "AES-CBC",
            iv: new Uint8Array(16), // 初始化向量，16个字节
        },
        await crypto.subtle.importKey("raw", new TextEncoder().encode(key), "AES-CBC", false, ["encrypt"]),
        encodedData
    );
    return btoa(new Uint8Array(encryptedData).reduce((data, byte) => data + String.fromCharCode(byte), ""));
  },
  async decrypt(encryptedData, key = 'fp_ld_8848_8848X') {
    const decodedData = atob(encryptedData).split("").map(char => char.charCodeAt(0));
    const decryptedData = await crypto.subtle.decrypt(
        {
            name: "AES-CBC",
            iv: new Uint8Array(16), // 初始化向量，16个字节
        },
        await crypto.subtle.importKey("raw", new TextEncoder().encode(key), "AES-CBC", false, ["decrypt"]),
        new Uint8Array(decodedData).buffer
    );
    const decoder = new TextDecoder();
    return decoder.decode(decryptedData);
  }
}

export default common



// WEBPACK FOOTER //
// ./src/request/api/common.js